import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const input = "w-full h-10 px-3 bg-[#1F2230] border border-[#3B4157] text-sm outline-none focus:border-orange-500";

export async function uploadUrls(urls) {
  const paths = [];
  let failed = 0;
  for (const url of urls) {
    try { paths.push((await api.post("/admin/upload-url", { url })).data.path); } catch { failed += 1; }
  }
  return { paths, failed };
}

export function SupplierImport({ onFill }) {
  const [url, setUrl] = useState("");
  const [text, setText] = useState("");
  const [needText, setNeedText] = useState(false);
  const [busy, setBusy] = useState("");

  const run = async () => {
    if (!/^https?:\/\//.test(url) && text.trim().length < 80) return toast.error("Įklijuokite tiekėjo prekės nuorodą");
    setBusy("Skaitomas puslapis...");
    try {
      const { data } = await api.post("/admin/import-url", { url, text });
      setBusy(`Įkeliamos nuotraukos (${data.images.length})...`);
      const { paths, failed } = await uploadUrls(data.images);
      onFill({ ...data, images: paths });
      toast.success(`Užpildyta: ${data.specs.length} parametrai, ${paths.length} nuotraukos. Patikrinkite ir įveskite kainą.`);
      if (failed) toast.error(`Nepavyko įkelti nuotraukų: ${failed}`);
      setNeedText(false);
    } catch (e) {
      if (e?.response?.data?.detail === "page_blocked") {
        setNeedText(true);
        toast.error("Tiekėjo puslapis neleidžia automatinio nuskaitymo. Nukopijuokite puslapio tekstą ir įklijuokite žemiau.");
      } else toast.error(errMsg(e));
    }
    setBusy("");
  };

  return (
    <div data-testid="supplier-import" className="sm:col-span-2 border border-orange-500/40 bg-orange-500/5 p-4 space-y-2">
      <div className="text-xs uppercase tracking-wider text-orange-400 flex items-center gap-2"><Sparkles className="w-4 h-4" />Užpildyti iš tiekėjo puslapio</div>
      <div className="flex flex-col sm:flex-row gap-2">
        <input data-testid="import-url-input" className={input} value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://tiekejas.lt/preke..." />
        <button type="button" data-testid="import-run-btn" onClick={run} disabled={!!busy}
          className="h-10 px-4 bg-orange-500 text-[#1F2230] font-display font-bold uppercase tracking-widest text-sm hover:bg-orange-400 disabled:opacity-60 inline-flex items-center justify-center gap-2 whitespace-nowrap">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Užpildyti
        </button>
      </div>
      {needText && (
        <textarea data-testid="import-text-input" rows={5} value={text} onChange={(e) => setText(e.target.value)}
          placeholder="Tiekėjo puslapyje paspauskite Ctrl+A, Ctrl+C ir įklijuokite čia. Nuotraukas įkelkite nuorodomis žemiau." className={`${input} h-auto py-2`} />
      )}
      <p className="text-xs text-slate-400 normal-case tracking-normal">{busy || "Pavadinimas, kodas, aprašymai LT/EN, techniniai duomenys ir nuotraukos užsipildys automatiškai (~15 s). Kainą įveskite patys."}</p>
    </div>
  );
}
